import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';

@Component({
  selector: 'app-text-placeholder',
  templateUrl: './text-placeholder.component.html',
  styleUrls: ['./text-placeholder.component.scss']
})
export class TextPlaceholderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}

@NgModule({
  declarations: [TextPlaceholderComponent],
  exports: [TextPlaceholderComponent],
  imports: [CommonModule],
})
export class TextPlaceholderModule { }
